// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'http://app.inbox.com.pa/API/',
  firebase: {
    apiKey: 'AIzaSyAlfLYmDUVXgHbKfjXJyieWNkZ2Agb57CQ',
    authDomain: 'protean-bazaar-237402.firebaseapp.com',
    databaseURL: 'https://protean-bazaar-237402.firebaseio.com',
    projectId: 'protean-bazaar-237402',
    storageBucket: 'protean-bazaar-237402.appspot.com',
    messagingSenderId: '704956448606',
  },
  provinces: [
    'Bocas del Toro',
    'Coclé',
    'Colón',
    'Chiriqui',
    'Darién',
    'Herrera',
    'Los Santos',
    'Panamá',
    'Panamá Oeste',
    'Veraguas',
  ],
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
